import { API_URL } from "../components/common/Config";
import {
  encryptPayload,
  normalizeEncryptedApiResponse,
} from "./customerCrypto";
import {
  getCompanySettings,
  resolveCustomerApiEncrypt,
} from "./companySettingsCache";

export async function fetchCompanyDetailsV2() {
  const authToken = localStorage.getItem("token");
  const prefix = localStorage.getItem("accessToken");
  if (!authToken) {
    return null;
  }

  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const url = `${API_URL}/ws-get-company-details-v2`;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  let response;
  if (useEncrypt) {
    const ep = encryptPayload({
      prefix: prefix || "",
    });
    if (!ep) {
      return null;
    }
    const body = new FormData();
    body.append("encrypted_payload", ep);
    response = await fetch(url, {
      method: "POST",
      headers,
      body,
    });
  } else {
    response = await fetch(url, {
      method: "GET",
      headers,
    });
  }

  const raw = await response.json();
  const data = normalizeEncryptedApiResponse(raw, useEncrypt) ?? raw;
  if (data?.success && data?.data?.company_details) {
    return data.data.company_details;
  }
  if (data?.company_details) {
    return data.company_details;
  }
  return null;
}

export default fetchCompanyDetailsV2;
